import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.exchangePlaidSuccess"],
  payload => payload
);
